import angular from 'angular';
import Home from './home/home';
import ErrorModule from './error/error';
import FoodPrepTime from './foodPrepTime/foodPrepTime'

let componentModule = angular.module('app.components', [
  Home,
  ErrorModule,
  FoodPrepTime
])
.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js